import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { LogOut } from 'lucide-react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import UserSubheader from './UserSubheader'
import { cn } from '@/lib/utils'
import { useHasSidebar } from 'app/frontend/base/hooks/useHasSidebar'

const UserHeader = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()
  const hasSidebar = useHasSidebar()

  return (
    <>
      <header className={cn('root-width', hasSidebar ? 'mx-0' : '')}>
        <div className='border-b-2 -ml-8 -mr-8 sm:h-[5.1rem] flex items-end pb-4 max-sm:-ml-4 max-sm:-mr-4'>
          <div className='ml-8 mr-8 grow flex justify-between items-center'>
            <h1 className='flex flex-col'>
              <span
                className={`text-base text-muted-foreground capitalize h-[1.6rem] leading-6 font-normal`}
              >
                {user?.battletag}
              </span>
              <div>{t('header.profile')}</div>
            </h1>
            <div className='flex gap-2'>
              <a href='/logout'>
                <Button variant='outline' className='flex gap-2'>
                  <LogOut width={14} />
                  {t('header.log-out')}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </header>
      <UserSubheader />
    </>
  )
}

export default UserHeader
